import { DateTime } from "luxon";
import { nanoid } from "nanoid";
import { CreateEditShipmentStop } from "../CreateEditShipmentData";

export const createEmptyStop = (date: DateTime): CreateEditShipmentStop => ({
  provisoryId: nanoid(), // Generate temporary ID for stopUnit references
  loadmeters: 0,
  weight: "",
  colli: "",
  length: "",
  width: "",
  height: "",
  time: "",
  cubicMeters: "",
  place: null,
  date,
  note: null,
  openingDate: null,
  ref: "",
  tag: "",
  contact: "",
  contactPhone: "",
  fix: false,
  pieces: [],
  openingTime: null,
  CMR_TAG_LOCKED: false,
  HAS_SORTING_DATE_BEEN_CHANGED: false,
});
